import {
	GET
} from "../util";
const platformDocumentUrl = 'api/platformdoc/';

const url = {
	generalTermAndConditionInfo: `${platformDocumentUrl}term-and-condition-info`
};

const platformDocumentApi = {
	getGeneralTermAndConditionInfo: (params = {}) => {
		return GET(url.generalTermAndConditionInfo, params);
	},
};

export {
	platformDocumentApi
};

